<div class="sidenav-header">
    <div class="gov-logo">
        <img src="../assets/img/stayamev-side.png" alt="">
        <ng-container *ngIf="!collapsed()">
            <img src="../assets/img/government-india-side.png" alt="">
        </ng-container>
    </div>
    <button class="menu-toggle" [class.close-menu]="collapsed()" (click)="this.collapsed.set(!this.collapsed())">
        <img src="../assets/img/menu-toggle-side.png" alt="">
    </button>
</div>
<mat-nav-list [disableRipple]="true">
    @for (item of menuItems(); track item.label) {
    <!-- <custom-menu-item [item]="item" [collapsed]="collapsed()" [level]="0" />
      -->
    <side-nav-menu [item]="item" [collapsed]="collapsed()" [level]="0" />
    }
</mat-nav-list>